// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2zcFX","content":"ManualTimeModal_content__27JY4"};